// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectStatus(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly_status?start_date=${startDate}`);
}
